import { fromJS } from 'immutable';
import * as searchActions from '../../actions/appraisalDemo/search';
import { fetchingState, defaultPageSize } from '../../constants';

const initialStats = {
  fields: {},
  searchOptions: {},
  codes: {},
  subdivisionCodes: {},
  propertyList: {
    pageSize: defaultPageSize,
    sortModel: [],
    currentPage: 0,
  },
};

export default (state = fromJS(initialStats), action) => {
  switch (action.type) {
    case searchActions.SEARCH_OPTIONS_FETCH_START:
      return state.setIn(['searchOptions', 'state'], fetchingState.FETCHING);
    case searchActions.SEARCH_OPTIONS_FETCH_SUCCESS:
      let newState = state.setIn(
        ['searchOptions', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['searchOptions', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case searchActions.SEARCH_OPTIONS_FETCH_ERROR:
      return state.setIn(['searchOptions', 'state'], fetchingState.ERROR);

    case searchActions.PROPERTY_FIELDS_FETCH_START:
      return state.setIn(['fields', 'state'], fetchingState.FETCHING);
    case searchActions.PROPERTY_FIELDS_FETCH_SUCCESS:
      newState = state.setIn(['fields', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['fields', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case searchActions.PROPERTY_FIELDS_FETCH_ERROR:
      return state.setIn(['fields', 'state'], fetchingState.ERROR);

    case searchActions.PROPERTY_SEARCH_START:
      return state.setIn(['propertyList', 'state'], fetchingState.FETCHING);
    case searchActions.PROPERTY_SEARCH_SUCCESS:
      newState = state.setIn(['propertyList', 'state'], fetchingState.LOADED);
      newState = newState.setIn(
        ['propertyList', 'totalCount'],
        action.data && action.data.totalProperty
          ? action.data.totalProperty.propCount
          : 0,
      );
      return newState.setIn(
        ['propertyList', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case searchActions.PROPERTY_SEARCH_ERROR:
      return state.setIn(['propertyList', 'state'], fetchingState.ERROR);

    case searchActions.PROPERTY_CHANGE_CURRENT_PAGE:
      return state.setIn(['propertyList', 'currentPage'], action.data);
    case searchActions.PROPERTY_CHANGE_PAGE_SIZE:
      return state.setIn(['propertyList', 'pageSize'], action.data);
    case searchActions.PROPERTY_CHANGE_SORT_MODEL:
      return state.setIn(['propertyList', 'sortModel'], fromJS(action.data));

    case searchActions.PROPERTY_CODES_FETCH_START:
      return state.setIn(['codes', 'state'], fetchingState.FETCHING);
    case searchActions.PROPERTY_CODES_FETCH_SUCCESS:
      newState = state.setIn(['codes', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['codes', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case searchActions.PROPERTY_CODES_FETCH_ERROR:
      return state.setIn(['codes', 'state'], fetchingState.ERROR);

    case searchActions.PROPERTY_SUBDIVISIONCODES_FETCH_START:
      return state.setIn(['subdivisionCodes', 'state'], fetchingState.FETCHING);
    case searchActions.PROPERTY_SUBDIVISIONCODES_FETCH_SUCCESS:
      newState = state.setIn(
        ['subdivisionCodes', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['subdivisionCodes', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case searchActions.PROPERTY_SUBDIVISIONCODES_FETCH_ERROR:
      return state.setIn(['subdivisionCodes', 'state'], fetchingState.ERROR);

    default:
      return state;
  }
};
